import { HTMLExtUtils } from '@ssml-editor/core';
import { PARAGRAPH_HTML_NODE_NAME, PARAGRAPH_TYPE, PARAGRAPH_MARK } from '@ssml-editor/vue';
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { SPEAK_HTML_NODE_NAME, SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                                      */
import 'cmu-pronouncing-dictionary';
/* empty css                                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                                        */
import '../../toolbar-menu/say-as/constant.js';
/* empty css                                        */
import '@element-plus/icons-vue';
/* empty css                                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                                       */
/* empty css                                         */
/* empty css                                     */
/* empty css                                                  */
/* empty css                                             */
/* empty css                                         */
import '../../toolbar-menu/voice/voice-menu.vue.js';

const pastePlugin = (editor) => {
  const { insertData } = editor;
  const newEditor = editor;
  newEditor.insertData = (data) => {
    if (!data.types.includes("application/x-slate-fragment")) {
      const text = data.getData("text/plain").trim();
      if (text.startsWith(
        `<${PARAGRAPH_HTML_NODE_NAME} ${HTMLExtUtils.typeKey}="${PARAGRAPH_TYPE}" data-mark="${PARAGRAPH_MARK}">`
      ) || text.startsWith(
        `<${SPEAK_HTML_NODE_NAME} ${HTMLExtUtils.typeKey}="${SPEAK_TYPE}"`
      )) {
        data.setData("text/html", text);
      }
    }
    insertData(data);
  };
  return newEditor;
};

export { pastePlugin };
//# sourceMappingURL=paste-plugin.js.map
